import iflHouseFormDictionary from '../../ru/ifl-house-form/ifl-house-form.dic.json';

export const iflHouseFormNS = {
  IFL_HOUSE_FORM: iflHouseFormDictionary,
};

export const iflHouseFormNamespaces = ['IFL_HOUSE_FORM'];
